import { render, staticRenderFns } from "./TestMessage.vue?vue&type=template&id=5bc29269&scoped=true"
import script from "./TestMessage.ts?vue&type=script&lang=ts&external"
export * from "./TestMessage.ts?vue&type=script&lang=ts&external"
import style0 from "./TestMessage.vue?vue&type=style&index=0&id=5bc29269&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc29269",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bc29269')) {
      api.createRecord('5bc29269', component.options)
    } else {
      api.reload('5bc29269', component.options)
    }
    module.hot.accept("./TestMessage.vue?vue&type=template&id=5bc29269&scoped=true", function () {
      api.rerender('5bc29269', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Core/components/TestMessage/TestMessage.vue"
export default component.exports